import type { ReactElement } from "react";
import "./IndicatorItem.scss";
import type { IndicatorKey } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/IndicatorKey.ts";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";
import useIndicatorParts from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/useIndicatorParts.ts";
import useIndicatorLabelAndUnit from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/useIndicatorLabelAndUnit.ts";

export interface Properties {
  summary: PeriodSummary;
  indicatorKey: IndicatorKey;
}

export default function IndicatorItem(props: Properties): ReactElement {
  const { bigPart, smallPart } = useIndicatorParts(
    props.summary,
    props.indicatorKey,
  );
  const { label, unit } = useIndicatorLabelAndUnit(props.indicatorKey);

  return (
    <div className="indicator-item">
      <div className="indicator-value">
        {bigPart ?? "--"}
        <span className="indicator-value-small">
          {smallPart} {bigPart !== undefined && unit}
        </span>
      </div>
      <div className="indicator-label">{label}</div>
    </div>
  );
}
